"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Multiselect = _interopRequireDefault(require("react-widgets/lib/Multiselect"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _getFormInitialValues = _interopRequireDefault(require("./getFormInitialValues"));
var _style = _interopRequireDefault(require("./style.css"));
var _undo = _interopRequireDefault(require("cccisd-icons/undo"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Boilerplate = window.cccisd.boilerplate;
var Appdefs = window.cccisd.appDefs;
var rolesBlacklist = ['guest', 'respondent', 'metricspawn'];
var ProductForm = function ProductForm(props) {
  var isEdit = props.isEdit,
    product = props.product,
    closeModal = props.closeModal;
  var _useState = (0, _react.useState)(isEdit),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)((0, _getFormInitialValues["default"])()),
    _useState4 = _slicedToArray(_useState3, 2),
    initialValues = _useState4[0],
    setInitialValues = _useState4[1];
  var roles = Appdefs.pawn.roles;
  (0, _react.useEffect)(function () {
    function fetchInitialValues() {
      return _fetchInitialValues.apply(this, arguments);
    }
    function _fetchInitialValues() {
      _fetchInitialValues = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _product$settingsExp, _product$settingsExp2, _product$settingsExp3, _product$settingsExp4, _product$settingsExp5, _product$settingsExp6;
        var existingProduct;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!isEdit || !product)) {
                _context.next = 3;
                break;
              }
              setIsLoading(false);
              return _context.abrupt("return");
            case 3:
              existingProduct = _objectSpread(_objectSpread({}, product), {}, {
                roles: roles.filter(function (role) {
                  return product.roleList.find(function (r) {
                    return r.handle === role.handle;
                  });
                }),
                notificationRoles: roles.filter(function (role) {
                  return product.notificationRoleList.find(function (r) {
                    return r.handle === role.handle;
                  });
                }),
                priceListing: product['settings.priceListing'],
                learnMoreUrl: product['settings.learnMoreUrl'],
                imageUrl: product['settings.imageUrl'],
                imageFilename: product['settings.imageFilename'],
                courseUrl: product['settings.courseUrl'],
                noLicenseCanInherit: product['settings.customNotifications.noLicenseCanInherit'] || initialValues.noLicenseCanInherit,
                noLicenseNoInherit: product['settings.customNotifications.noLicenseNoInherit'] || initialValues.noLicenseNoInherit,
                expiredCanInherit: product['settings.customNotifications.expiredCanInherit'] || initialValues.expiredCanInherit,
                expiredNoInherit: product['settings.customNotifications.expiredNoInherit'] || initialValues.expiredNoInherit,
                voucherStart: product['settings.customNotifications.voucherStart'] || initialValues.voucherStart,
                voucherRenew: product['settings.customNotifications.voucherRenew'] || initialValues.voucherRenew,
                voucherExtend: product['settings.customNotifications.voucherExtend'] || initialValues.voucherExtend,
                emailVoucherSingleLicense: {
                  subject: product['settings.emailConfig.voucherSingleLicense.subject'] || initialValues.emailVoucherSingleLicense.subject,
                  body: product['settings.emailConfig.voucherSingleLicense.body'] || initialValues.emailVoucherSingleLicense.body,
                  actionText: product['settings.emailConfig.voucherSingleLicense.actionText'] || initialValues.emailVoucherSingleLicense.actionText,
                  outroLines: product['settings.emailConfig.voucherSingleLicense.outroLines'] || initialValues.emailVoucherSingleLicense.outroLines
                },
                emailAdminRequired: {
                  subject: product['settings.emailConfig.adminRequired.subject'] || initialValues.emailAdminRequired.subject,
                  body: product['settings.emailConfig.adminRequired.body'] || initialValues.emailAdminRequired.body
                },
                expiryNotifications: {
                  advance: {
                    timeframe: product['settings.expiryNotifications.advance.timeframe'] || initialValues.expiryNotifications.advance.timeframe,
                    email: {
                      enabled: (_product$settingsExp = product['settings.expiryNotifications.advance.email.enabled']) !== null && _product$settingsExp !== void 0 ? _product$settingsExp : initialValues.expiryNotifications.advance.email.enabled,
                      subject: product['settings.expiryNotifications.advance.email.subject'] || initialValues.expiryNotifications.advance.email.subject,
                      body: product['settings.expiryNotifications.advance.email.body'] || initialValues.expiryNotifications.advance.email.body,
                      actionText: product['settings.expiryNotifications.advance.email.actionText'] || initialValues.expiryNotifications.advance.email.actionText,
                      outroLines: product['settings.expiryNotifications.advance.email.outroLines'] || initialValues.expiryNotifications.advance.email.outroLines
                    },
                    alert: {
                      enabled: (_product$settingsExp2 = product['settings.expiryNotifications.advance.alert.enabled']) !== null && _product$settingsExp2 !== void 0 ? _product$settingsExp2 : initialValues.expiryNotifications.advance.alert.enabled,
                      body: product['settings.expiryNotifications.advance.alert.body'] || initialValues.expiryNotifications.advance.alert.body,
                      actionText: product['settings.expiryNotifications.advance.alert.actionText'] || initialValues.expiryNotifications.advance.alert.actionText
                    }
                  },
                  near: {
                    timeframe: product['settings.expiryNotifications.near.timeframe'] || initialValues.expiryNotifications.near.timeframe,
                    email: {
                      enabled: (_product$settingsExp3 = product['settings.expiryNotifications.near.email.enabled']) !== null && _product$settingsExp3 !== void 0 ? _product$settingsExp3 : initialValues.expiryNotifications.near.email.enabled,
                      subject: product['settings.expiryNotifications.near.email.subject'] || initialValues.expiryNotifications.near.email.subject,
                      body: product['settings.expiryNotifications.near.email.body'] || initialValues.expiryNotifications.near.email.body,
                      actionText: product['settings.expiryNotifications.near.email.actionText'] || initialValues.expiryNotifications.near.email.actionText,
                      outroLines: product['settings.expiryNotifications.near.email.outroLines'] || initialValues.expiryNotifications.near.email.outroLines
                    },
                    alert: {
                      enabled: (_product$settingsExp4 = product['settings.expiryNotifications.near.alert.enabled']) !== null && _product$settingsExp4 !== void 0 ? _product$settingsExp4 : initialValues.expiryNotifications.near.alert.enabled,
                      body: product['settings.expiryNotifications.near.alert.body'] || initialValues.expiryNotifications.near.alert.body,
                      actionText: product['settings.expiryNotifications.near.alert.actionText'] || initialValues.expiryNotifications.near.alert.actionText
                    }
                  },
                  expired: {
                    email: {
                      enabled: (_product$settingsExp5 = product['settings.expiryNotifications.expired.email.enabled']) !== null && _product$settingsExp5 !== void 0 ? _product$settingsExp5 : initialValues.expiryNotifications.expired.email.enabled,
                      subject: product['settings.expiryNotifications.expired.email.subject'] || initialValues.expiryNotifications.expired.email.subject,
                      body: product['settings.expiryNotifications.expired.email.body'] || initialValues.expiryNotifications.expired.email.body,
                      actionText: product['settings.expiryNotifications.expired.email.actionText'] || initialValues.expiryNotifications.expired.email.actionText,
                      outroLines: product['settings.expiryNotifications.expired.email.outroLines'] || initialValues.expiryNotifications.expired.email.outroLines
                    },
                    alert: {
                      enabled: (_product$settingsExp6 = product['settings.expiryNotifications.expired.alert.enabled']) !== null && _product$settingsExp6 !== void 0 ? _product$settingsExp6 : initialValues.expiryNotifications.expired.alert.enabled,
                      body: product['settings.expiryNotifications.expired.alert.body'] || initialValues.expiryNotifications.expired.alert.body,
                      actionText: product['settings.expiryNotifications.expired.alert.actionText'] || initialValues.expiryNotifications.expired.alert.actionText
                    }
                  }
                }
              });
              setInitialValues(existingProduct);
              setIsLoading(false);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fetchInitialValues.apply(this, arguments);
    }
    fetchInitialValues();
  }, []);
  var validate = function validate(values) {
    var errors = {};
    if (!values.label) {
      errors.label = 'Title is required';
    }
    if (!values.handle) {
      errors.handle = 'Internal Name is required';
    }
    if (/[^0-9a-zA-Z_]/g.test(values.handle)) {
      errors.handle = 'Internal Name cannot contain white spaces or special characters';
    }
    if (!values.sku) {
      errors.sku = 'SKU is required';
    }
    if (/[^0-9a-zA-Z_]/g.test(values.sku)) {
      errors.sku = 'SKU cannot contain white spaces or special characters';
    }
    if (values.sku.length > 64) {
      errors.sku = 'SKU is too long';
    }
    if (values.roles.length < 1) {
      errors.roles = 'Must select at least one licensed role';
    }
    if (parseFloat(values.durationMonths) !== parseInt(values.durationMonths, 10)) {
      errors.durationMonths = 'Duration should be a whole number of months';
    } else if (parseInt(values.durationMonths, 10) < 1) {
      errors.durationMonths = 'Duration should be greater than 1 month';
    }
    ['purchaseUrl', 'learnMoreUrl', 'courseUrl'].forEach(function (key) {
      try {
        if (values[key] && !values[key].startsWith('https://')) {
          errors[key] = 'URL should start with https://';
        } else if (values[key]) {
          // eslint-disable-next-line no-new
          new URL(values[key]); // will throw error if url is invalid
        }
      } catch (e) {
        errors[key] = 'URL is not valid';
      }
    });
    return errors;
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values, actions) {
      var _values$expiryNotific, _values$expiryNotific2, _values$expiryNotific3, _values$expiryNotific4, _values$expiryNotific5, _values$expiryNotific6;
      var response, errors;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            values = _objectSpread(_objectSpread({}, values), {}, {
              roles: values.roles.map(function (r) {
                return r.handle;
              }),
              notificationRoles: values.notificationRoles.map(function (r) {
                return r.handle;
              }),
              settings: {
                priceListing: values.priceListing,
                learnMoreUrl: values.learnMoreUrl,
                imageUrl: values.imageUrl,
                imageFilename: values.imageFilename,
                courseUrl: values.courseUrl,
                customNotifications: {
                  noLicenseCanInherit: values.noLicenseCanInherit || initialValues.noLicenseCanInherit,
                  noLicenseNoInherit: values.noLicenseNoInherit || initialValues.noLicenseNoInherit,
                  expiredCanInherit: values.expiredCanInherit || initialValues.expiredCanInherit,
                  expiredNoInherit: values.expiredNoInherit || initialValues.expiredNoInherit,
                  voucherStart: values.voucherStart || initialValues.voucherStart,
                  voucherRenew: values.voucherRenew || initialValues.voucherRenew,
                  voucherExtend: values.voucherExtend || initialValues.voucherExtend
                },
                emailConfig: {
                  voucherSingleLicense: {
                    subject: values.emailVoucherSingleLicense.subject || initialValues.emailVoucherSingleLicense.subject,
                    body: values.emailVoucherSingleLicense.body || initialValues.emailVoucherSingleLicense.body,
                    actionText: values.emailVoucherSingleLicense.actionText || initialValues.emailVoucherSingleLicense.actionText,
                    outroLines: values.emailVoucherSingleLicense.outroLines || initialValues.emailVoucherSingleLicense.outroLines
                  },
                  adminRequired: {
                    subject: values.emailAdminRequired.subject || initialValues.emailAdminRequired.subject,
                    body: values.emailAdminRequired.body || initialValues.emailAdminRequired.body
                  }
                },
                expiryNotifications: {
                  advance: {
                    timeframe: values.expiryNotifications.advance.timeframe || initialValues.expiryNotifications.advance.timeframe,
                    email: {
                      enabled: (_values$expiryNotific = values.expiryNotifications.advance.email.enabled) !== null && _values$expiryNotific !== void 0 ? _values$expiryNotific : initialValues.expiryNotifications.advance.email.enabled,
                      subject: values.expiryNotifications.advance.email.subject || initialValues.expiryNotifications.advance.email.subject,
                      body: values.expiryNotifications.advance.email.body || initialValues.expiryNotifications.advance.email.body,
                      actionText: values.expiryNotifications.advance.email.actionText || initialValues.expiryNotifications.advance.email.actionText,
                      outroLines: values.expiryNotifications.advance.email.outroLines || initialValues.expiryNotifications.advance.email.outroLines
                    },
                    alert: {
                      enabled: (_values$expiryNotific2 = values.expiryNotifications.advance.alert.enabled) !== null && _values$expiryNotific2 !== void 0 ? _values$expiryNotific2 : initialValues.expiryNotifications.advance.alert.enabled,
                      body: values.expiryNotifications.advance.alert.body || initialValues.expiryNotifications.advance.alert.body,
                      actionText: values.expiryNotifications.advance.alert.actionText || initialValues.expiryNotifications.advance.alert.actionText
                    }
                  },
                  near: {
                    timeframe: values.expiryNotifications.near.timeframe || initialValues.expiryNotifications.near.timeframe,
                    email: {
                      enabled: (_values$expiryNotific3 = values.expiryNotifications.near.email.enabled) !== null && _values$expiryNotific3 !== void 0 ? _values$expiryNotific3 : initialValues.expiryNotifications.near.email.enabled,
                      subject: values.expiryNotifications.near.email.subject || initialValues.expiryNotifications.near.email.subject,
                      body: values.expiryNotifications.near.email.body || initialValues.expiryNotifications.near.email.body,
                      actionText: values.expiryNotifications.near.email.actionText || initialValues.expiryNotifications.near.email.actionText,
                      outroLines: values.expiryNotifications.near.email.outroLines || initialValues.expiryNotifications.near.email.outroLines
                    },
                    alert: {
                      enabled: (_values$expiryNotific4 = values.expiryNotifications.near.alert.enabled) !== null && _values$expiryNotific4 !== void 0 ? _values$expiryNotific4 : initialValues.expiryNotifications.near.alert.enabled,
                      body: values.expiryNotifications.near.alert.body || initialValues.expiryNotifications.near.alert.body,
                      actionText: values.expiryNotifications.near.alert.actionText || initialValues.expiryNotifications.near.alert.actionText
                    }
                  },
                  expired: {
                    email: {
                      enabled: (_values$expiryNotific5 = values.expiryNotifications.expired.email.enabled) !== null && _values$expiryNotific5 !== void 0 ? _values$expiryNotific5 : initialValues.expiryNotifications.expired.email.enabled,
                      subject: values.expiryNotifications.expired.email.subject || initialValues.expiryNotifications.expired.email.subject,
                      body: values.expiryNotifications.expired.email.body || initialValues.expiryNotifications.expired.email.body,
                      actionText: values.expiryNotifications.expired.email.actionText || initialValues.expiryNotifications.expired.email.actionText,
                      outroLines: values.expiryNotifications.expired.email.outroLines || initialValues.expiryNotifications.expired.email.outroLines
                    },
                    alert: {
                      enabled: (_values$expiryNotific6 = values.expiryNotifications.expired.alert.enabled) !== null && _values$expiryNotific6 !== void 0 ? _values$expiryNotific6 : initialValues.expiryNotifications.expired.alert.enabled,
                      body: values.expiryNotifications.expired.alert.body || initialValues.expiryNotifications.expired.alert.body,
                      actionText: values.expiryNotifications.expired.alert.actionText || initialValues.expiryNotifications.expired.alert.actionText
                    }
                  }
                }
              }
            });
            if (!isEdit) {
              _context2.next = 7;
              break;
            }
            _context2.next = 4;
            return _cccisdAxios["default"].put(Boilerplate.route('licensing.api.product.update', {
              product: product.productId
            }), values);
          case 4:
            _context2.t0 = _context2.sent;
            _context2.next = 10;
            break;
          case 7:
            _context2.next = 9;
            return _cccisdAxios["default"].post(Boilerplate.route('licensing.api.product.create'), values);
          case 9:
            _context2.t0 = _context2.sent;
          case 10:
            response = _context2.t0;
            if (response.data.status === 'error') {
              errors = {};
              Object.keys(response.data.errors).forEach(function (field) {
                if (['label', 'handle', 'sku', 'roles', 'notificationRoles', 'purchaseUrl', 'durationMonths'].includes(field)) {
                  errors[field] = response.data.errors[field][0];
                } else {
                  (0, _cccisdNotification["default"])({
                    message: 'Error creating licensed product:',
                    data: _defineProperty({}, field, response.data.errors[field]),
                    duration: 0,
                    type: 'danger'
                  });
                }
              });
              actions.setErrors(errors);
            } else {
              (0, _cccisdNotification["default"])({
                message: isEdit ? 'Licensed Product updated successfully!' : 'Licensed Product created successfully!',
                duration: 3000,
                type: 'success'
              });
              closeModal();
            }
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var resetValues = function resetValues(values, submitForm) {
    var initValues = (0, _getFormInitialValues["default"])();
    var changedFields = /*#__PURE__*/_react["default"].createElement("div", null, "Are you sure you want to lose your changes to the following custom Notification fields?", /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "No License but Can Inherit"), /*#__PURE__*/_react["default"].createElement("li", null, "No License and Cannot Inherit"), /*#__PURE__*/_react["default"].createElement("li", null, "Expired License but Can Inherit to Renew"), /*#__PURE__*/_react["default"].createElement("li", null, "Expired License and Cannot Inherit to Renew"), /*#__PURE__*/_react["default"].createElement("li", null, "Activating License with a Voucher"), /*#__PURE__*/_react["default"].createElement("li", null, "Renewing License with a Voucher"), /*#__PURE__*/_react["default"].createElement("li", null, "Extending License with a Voucher")));
    (0, _cccisdConfirm["default"])({
      message: 'Restore default values?',
      description: changedFields,
      confirmLabel: 'Yes',
      abortLabel: 'No'
    }).then(function () {
      values.noLicenseCanInherit = initValues.noLicenseCanInherit;
      values.noLicenseNoInherit = initValues.noLicenseNoInherit;
      values.expiredCanInherit = initValues.expiredCanInherit;
      values.expiredNoInherit = initValues.expiredNoInherit;
      values.voucherStart = initValues.voucherStart;
      values.voucherRenew = initValues.voucherRenew;
      values.voucherExtend = initValues.voucherExtend;
      submitForm();
    });
  };
  var renderResetValueButton = function renderResetValueButton(formikField, values, fieldName, submitForm) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '100%'
      }
    }, formikField), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginLeft: '1em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Restore default value"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-success btn-sm",
      onClick: function onClick() {
        var initValues = (0, _getFormInitialValues["default"])();
        (0, _cccisdConfirm["default"])({
          message: 'Restore default values?',
          description: 'Are you sure you want to lose your changes to this custom field?',
          confirmLabel: 'Yes',
          abortLabel: 'No'
        }).then(function () {
          values[fieldName] = initValues[fieldName];
          submitForm();
        });
      }
    }, /*#__PURE__*/_react["default"].createElement(_undo["default"], null)))));
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: isLoading,
    removeChildren: true
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: initialValues,
    onSubmit: handleSubmit,
    validate: validate
  }, function (_ref2) {
    var values = _ref2.values,
      submitForm = _ref2.submitForm,
      touched = _ref2.touched,
      setFieldValue = _ref2.setFieldValue;
    // automatically set handle and sku to slug and upper case of label
    var slug = values.label.replace(/[\s\t]+/g, '_').replace(/[^0-9a-zA-Z_]/g, '').toLowerCase();
    var uppercase = values.label.replace(/[\s\t]+/g, '').replace(/[^0-9a-zA-Z_]/g, '').toUpperCase();
    if (!touched.label && !touched.handle && !isEdit && values.handle !== slug) {
      setFieldValue('handle', slug, false);
    }
    if (!touched.label && !touched.sku && !isEdit && values.sku !== uppercase) {
      setFieldValue('sku', uppercase, false);
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("section", {
      className: "alert alert-info"
    }, /*#__PURE__*/_react["default"].createElement("h3", null, "Product Details"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-12"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "label",
      label: "Title*",
      component: _cccisdFormik.CccisdInput
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "handle",
      label: "Internal Name*",
      component: _cccisdFormik.CccisdInput
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "sku",
      label: "SKU*",
      component: _cccisdFormik.CccisdInput
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-3"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "durationMonths",
      label: "Duration (months)*",
      component: _cccisdFormik.CccisdInput,
      type: "number",
      step: "1",
      min: "1"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-3"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "priceListing",
      label: "Price Listing",
      component: _cccisdFormik.CccisdInput
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement("label", null, "Product Image"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "imageUrl",
      render: function render(_ref3) {
        var form = _ref3.form;
        return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
          onChange: function onChange(_ref4) {
            var name = _ref4.name,
              url = _ref4.url;
            form.setFieldValue('imageUrl', url, true);
            form.setFieldValue('imageFilename', name, true);
          },
          trigger: /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-default"
          }, values.imageUrl ? 'Change' : 'Upload')
        });
      }
    }), values.imageFilename && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: /*#__PURE__*/_react["default"].createElement("img", {
        style: {
          maxWidth: '250px',
          maxHeight: '250px'
        },
        src: values.imageUrl,
        alt: "".concat(values.label)
      })
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _style["default"].filename
    }, values.imageFilename)))))), /*#__PURE__*/_react["default"].createElement("section", {
      className: "alert alert-info"
    }, /*#__PURE__*/_react["default"].createElement("h3", null, "External URLs"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "purchaseUrl",
      label: "Purchase URL",
      component: _cccisdFormik.CccisdInput
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "learnMoreUrl",
      label: "Learn More URL",
      component: _cccisdFormik.CccisdInput
    })), /*#__PURE__*/_react["default"].createElement("section", {
      className: "alert alert-info"
    }, /*#__PURE__*/_react["default"].createElement("h3", null, "Role Settings"), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "roles"
    }, function (fieldProps) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, _extends({}, fieldProps, {
        label: "Roles Which Require a License*"
      }), /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], {
        value: fieldProps.field.value,
        data: roles.filter(function (r) {
          return !rolesBlacklist.includes(r.handle);
        }),
        dataKey: "handle",
        textField: "label",
        onChange: function onChange(vals) {
          fieldProps.form.setFieldValue(fieldProps.field.name, vals, false);
          fieldProps.field.onChange();
        }
      }));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-lg-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "notificationRoles"
    }, function (fieldProps) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, _extends({}, fieldProps, {
        label: "Roles Prompted on Activation/Expiration"
      }), /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], {
        value: fieldProps.field.value,
        data: roles.filter(function (r) {
          return !rolesBlacklist.includes(r.handle);
        }),
        dataKey: "handle",
        textField: "label",
        onChange: function onChange(vals) {
          fieldProps.form.setFieldValue(fieldProps.field.name, vals, false);
          fieldProps.field.onChange();
        }
      }));
    })))), /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
      title: "Advanced Settings"
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: "alert alert-info"
    }, /*#__PURE__*/_react["default"].createElement("h3", null, "Course URL"), /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        marginBottom: '1em'
      }
    }, "Add the course URL that will be shown in the ", /*#__PURE__*/_react["default"].createElement("i", null, "Course Content"), " column in the table.", ' ', /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: 'red'
      }
    }, "This link should only be used to verify the course internally", ' '), ' ', "and should not be used externally."), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "courseUrl",
      label: "Internal Only Course Link",
      component: _cccisdFormik.CccisdInput
    })), /*#__PURE__*/_react["default"].createElement("section", {
      className: "alert alert-info"
    }, /*#__PURE__*/_react["default"].createElement("h3", null, "Custom Notification Prompts"), /*#__PURE__*/_react["default"].createElement("p", null, "This is what displays when a user (specified in the role(s) above) attempts to log in and access restricted content based on the below use cases."), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: '1em'
      }
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-success",
      onClick: function onClick() {
        resetValues(values, submitForm);
      }
    }, /*#__PURE__*/_react["default"].createElement(_undo["default"], {
      spaceRight: true
    }), "Restore default values")), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("h4", null, "Product Access"), renderResetValueButton( /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "noLicenseCanInherit",
      label: "Case: No License but Can Inherit",
      component: _cccisdFormik.CccisdWysiwyg
    }), values, 'noLicenseCanInherit', submitForm), renderResetValueButton( /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "noLicenseNoInherit",
      label: "Case: No License and None Available to Inherit",
      component: _cccisdFormik.CccisdWysiwyg
    }), values, 'noLicenseNoInherit', submitForm), renderResetValueButton( /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiredCanInherit",
      label: "Case: Expired License but Can Inherit to Renew",
      component: _cccisdFormik.CccisdWysiwyg
    }), values, 'expiredCanInherit', submitForm), renderResetValueButton( /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiredNoInherit",
      label: "Case: Expired License and Cannot Inherit to Renew",
      component: _cccisdFormik.CccisdWysiwyg
    }), values, 'expiredNoInherit', submitForm), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("h4", null, "Vouchers"), renderResetValueButton( /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "voucherStart",
      label: "Case: Activating License with a Voucher",
      component: _cccisdFormik.CccisdWysiwyg
    }), values, 'voucherStart', submitForm), renderResetValueButton( /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "voucherRenew",
      label: "Case: Renewing License with a Voucher",
      component: _cccisdFormik.CccisdWysiwyg
    }), values, 'voucherRenew', submitForm), renderResetValueButton( /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "voucherExtend",
      label: "Case: Extending License with a Voucher",
      component: _cccisdFormik.CccisdWysiwyg
    }), values, 'voucherExtend', submitForm)), /*#__PURE__*/_react["default"].createElement("section", {
      className: "alert alert-info"
    }, /*#__PURE__*/_react["default"].createElement("h3", null, "Automated Email Configuration"), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("h4", null, "Voucher with Single License (includes link)"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "emailVoucherSingleLicense.subject",
      label: "Subject",
      component: _cccisdFormik.CccisdInput
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "emailVoucherSingleLicense.body",
      label: "Body (upper)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "emailVoucherSingleLicense.actionText",
      label: "Button Text",
      component: _cccisdFormik.CccisdInput
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "emailVoucherSingleLicense.outroLines",
      label: "Body (lower)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("h4", null, "Vouchers that Require an Admin (2+ licenses)"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "emailAdminRequired.subject",
      label: "Subject",
      component: _cccisdFormik.CccisdInput
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "emailAdminRequired.body",
      label: "Body",
      component: _cccisdFormik.CccisdTextarea,
      rows: "10"
    }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("p", null, "NOTE: You can use the following as variable replacements:", /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "%PRODUCT% - The name of the product"), /*#__PURE__*/_react["default"].createElement("li", null, "%DURATION% - The duration of a license"), /*#__PURE__*/_react["default"].createElement("li", null, "%QUANTITY% - The quantity of licenses purchased"), /*#__PURE__*/_react["default"].createElement("li", null, "%FIRSTNAME% - The first name of the customer"), /*#__PURE__*/_react["default"].createElement("li", null, "%LASTNAME% - The last name of the customer")))), /*#__PURE__*/_react["default"].createElement("section", {
      className: "alert alert-info"
    }, /*#__PURE__*/_react["default"].createElement("h3", null, "License Expiry Notifications"), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("h4", null, "Advance Warning"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.advance.timeframe",
      label: "Timeframe (in days)",
      component: _cccisdFormik.CccisdInput,
      type: "number",
      min: "1"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.advance.email.enabled",
      label: "Email Enabled",
      component: _cccisdFormik.CccisdToggle
    }), values.expiryNotifications.advance.email.enabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.advance.email.subject",
      label: "Email Subject",
      component: _cccisdFormik.CccisdInput
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.advance.email.body",
      label: "Email Body (upper)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.advance.email.actionText",
      label: "Email Button Text",
      component: _cccisdFormik.CccisdInput
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.advance.email.outroLines",
      label: "Email Body (lower)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.advance.alert.enabled",
      label: "Alert Enabled",
      component: _cccisdFormik.CccisdToggle
    }), values.expiryNotifications.advance.alert.enabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.advance.alert.body",
      label: "Alert Body (upper)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.advance.alert.actionText",
      label: "Alert Button Text",
      component: _cccisdFormik.CccisdInput
    })), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("h4", null, "Near Warning"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.near.timeframe",
      label: "Timeframe (in days)",
      component: _cccisdFormik.CccisdInput,
      type: "number",
      min: "1"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.near.email.enabled",
      label: "Email Enabled",
      component: _cccisdFormik.CccisdToggle
    }), values.expiryNotifications.near.email.enabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.near.email.subject",
      label: "Email Subject",
      component: _cccisdFormik.CccisdInput
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.near.email.body",
      label: "Email Body (upper)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.near.email.actionText",
      label: "Email Button Text",
      component: _cccisdFormik.CccisdInput
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.near.email.outroLines",
      label: "Email Body (lower)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.near.alert.enabled",
      label: "Alert Enabled",
      component: _cccisdFormik.CccisdToggle
    }), values.expiryNotifications.near.alert.enabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.near.alert.body",
      label: "Alert Body (upper)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.near.alert.actionText",
      label: "Alert Button Text",
      component: _cccisdFormik.CccisdInput
    })), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("h4", null, "Expired"), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.expired.email.enabled",
      label: "Email Enabled",
      component: _cccisdFormik.CccisdToggle
    }), values.expiryNotifications.expired.email.enabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.expired.email.subject",
      label: "Email Subject",
      component: _cccisdFormik.CccisdInput
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.expired.email.body",
      label: "Email Body (upper)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.expired.email.actionText",
      label: "Email Button Text",
      component: _cccisdFormik.CccisdInput
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.expired.email.outroLines",
      label: "Email Body (lower)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    })), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.expired.alert.enabled",
      label: "Alert Enabled",
      component: _cccisdFormik.CccisdToggle
    }), values.expiryNotifications.expired.alert.enabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.expired.alert.body",
      label: "Alert Body (upper)",
      component: _cccisdFormik.CccisdTextarea,
      rows: "7"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "expiryNotifications.expired.alert.actionText",
      label: "Alert Button Text",
      component: _cccisdFormik.CccisdInput
    })), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("p", null, "NOTE: You can use the following as variable replacements:", /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("li", null, "%PRODUCT% - The name of the product"), /*#__PURE__*/_react["default"].createElement("li", null, "%FIRSTNAME% - The first name of the customer"), /*#__PURE__*/_react["default"].createElement("li", null, "%LASTNAME% - The last name of the customer"), /*#__PURE__*/_react["default"].createElement("li", null, "%EXPIRYDATE% - The date of expiry for a license"), /*#__PURE__*/_react["default"].createElement("li", null, "%TIMEFRAME% - The amount of days before a license expires")))))), /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-primary",
      type: "submit",
      style: {
        marginTop: '1em'
      },
      onClick: submitForm
    }, "Submit"));
  }));
};
ProductForm.propTypes = {
  isEdit: _propTypes["default"].bool,
  product: _propTypes["default"].object
};
ProductForm.defaultProps = {
  isEdit: false
};
var _default = exports["default"] = ProductForm;